import fetch from '@/common/fetch';
import { apiName } from '@/api/index';

const path = `${apiName}/enduser`;

// 公告
const viewnoticeurl = `${path}/viewnotice`;
// 发送信息
const sendchaturl = `${path}/sendchat`;
// 聊天记录
const viewchaturl = `${path}/viewchat`;
// 平台服务
const staffserviceurl = `${path}/staffservice`;
// Withdraw
const Withdraw_apply_uri = `${path}/cash_apply`;
// profile
const profileuri = `${path}/profile`;
// profile
const withdraw_applyuri = `${path}/cash_apply`;
// notify_blockchain
const notify_blockchainuri = `${path}/notify_blockchain`;
// journals
const journalsuri = `${path}/journals`;
// signin_list
const signin_listsuri = `${path}/signin_list`;
// modifyenduser
const modifyenduseruri = `${path}/modifyenduser`;
// setmodifypwd
const modifypwduri = `${path}/modifypwd`;
// 修改邮箱
const rebindtelormailuri = `${path}/rebindtelormail`;
// 重置密码
const sendbizpwduri = `${path}/sendbizpwd`;
// improvingdata实名认证
const improvingdatauri = `${path}/improvingdata`;
const setpaymenturi = `${path}/set_payment`;

// 用户信息
const bb_personalinformationuri = `${path}/bb_personalinformation`;
// 拼团
const bb_activity_coupons_listuri = `${path}/bb_activity_coupons_list`;
// 抽奖
const bb_activity_draw_listuri = `${path}/bb_activity_draw_list`;
// 优惠券领取
const bb_coupons_adduri = `${path}/bb_coupons_add`;
// acct_summary
const acct_summaryuri = `${path}/acct_summary`;

const personalinformation = data => (fetch({
  url: bb_personalinformationuri,
  method: 'post',
  data,
}));
const activitycouponslist = data => (fetch({
  url: bb_activity_coupons_listuri,
  method: 'post',
  data,
}));
const activityDrawList = data => (fetch({
  url: bb_activity_draw_listuri,
  method: 'post',
  data,
}));
const couponsadd = data => (fetch({
  url: bb_coupons_adduri,
  method: 'post',
  data,
}));
const acctsummary = data => (fetch({
  url: acct_summaryuri,
  method: 'post',
  data,
}));


const setpayment = data => (fetch({
  url: setpaymenturi,
  method: 'post',
  data,
}));
const setimprovingdat = data => (fetch({
  url: improvingdatauri,
  method: 'post',
  data,
}));
const setsendbizpwduri = data => (fetch({
  url: sendbizpwduri,
  method: 'post',
  data,
}));
const setrebindtelormail = data => (fetch({
  url: rebindtelormailuri,
  method: 'post',
  data,
}));
const setmodifypwd = data => (fetch({
  url: modifypwduri,
  method: 'post',
  data,
}));
const setmodifyenduser = data => (fetch({
  url: modifyenduseruri,
  method: 'post',
  data,
}));
const getsigninlist = data => (fetch({
  url: signin_listsuri,
  method: 'post',
  data,
}));
const getjournals = data => (fetch({
  url: journalsuri,
  method: 'post',
  data,
}));
const Withdraappy = data => (fetch({
  url: withdraw_applyuri,
  method: 'post',
  data,
}));
const getprofile = data => (fetch({
  url: profileuri,
  method: 'post',
  data,
}));
const getviewnotice = data => (fetch({
  url: viewnoticeurl,
  method: 'post',
  data,
}));
const Withdrawapply = data => (fetch({
  url: Withdraw_apply_uri,
  method: 'post',
  data,
}));
const sendchat = data => (fetch({
  url: sendchaturl,
  method: 'post',
  data,
}));
const getViewchat = data => (fetch({
  url: viewchaturl,
  method: 'post',
  data,
}));
const getStaffservice = data => (fetch({
  url: staffserviceurl,
  method: 'post',
  data,
}));
const getnotifyblockchain = data => (fetch({
  url: notify_blockchainuri,
  method: 'post',
  data,
}));

export default {
  getprofile,
  setimprovingdat,
  setmodifyenduser,
  getviewnotice,
  getsigninlist,
  sendchat,
  Withdrawapply,
  getViewchat,
  getStaffservice,
  acctsummary,
  Withdraappy,
  getnotifyblockchain,
  getjournals,
  setmodifypwd,
  setrebindtelormail,
  setsendbizpwduri,
  setpayment,
  personalinformation,
  activitycouponslist,
  activityDrawList,
  couponsadd
};



// WEBPACK FOOTER //
// ./src/api/enduser/index.js